<template>

<el-container class="back row">
  <el-aside v-if="!menuDetail" class="router-fields" style="padding: 15px">
    <div class="row"><img src="https://jzxq123.cn/data/files/robot-logo.png" class="logo"/></div>
    <div class="row-start round-box" style="margin-top: 15px; background-color: white" @click="closeMenuDetail">
    <el-icon style="font-size:16px;"><ArrowRightBold /></el-icon>
    </div>
    <div class="row-start round-box" style="margin-top: 15px" @click="goPrompt">
      <el-tooltip effect="dark" content="提示词" placement="right">
      <el-icon style="font-size:16px;"><EditPen /></el-icon>
      </el-tooltip>
    </div>

    <div class="row-start round-box" @click="goChat2BI">
      <el-tooltip effect="dark" content="ChatBI" placement="right">
      <el-icon style="font-size:16px;"><PieChart /></el-icon>
      </el-tooltip>
    </div>

    <div class="row-start round-box" @click="goReader">
      <el-tooltip effect="dark" content="智能阅读" placement="right">
      <el-icon style="font-size:16px;"><Reading /></el-icon>
      </el-tooltip>
    </div>
  </el-aside>
  <el-aside v-else class="router-fields">
    <div class="row-between" style="margin-top: 20px;">
      <div class="row">
      <div class="row"><img src="https://jzxq123.cn/data/files/robot-logo.png" class="logo"/></div>
      <div style="font-size:22px; font-weight: bold;color:black;margin-left: 8px">噼里啪啦</div>
      </div>
      <el-icon @click="closeMenuDetail"  style="width: 30px;height: 30px;border-radius: 50%;"><ArrowLeftBold /></el-icon>
    </div>
    <div class="primary-button row" style="margin-top: 20px;width: 180px">
      <el-icon style="font-size: 16px"><Plus /></el-icon>
      <span style="margin-left:10px; ">新建对话</span>
    </div>

      <div class="row-start menu-box" style="margin-top: 15px" @click="goPrompt">
        <el-icon style="font-size:16px;"><EditPen /></el-icon>
        <span style="margin-left:15px; font-size: 14px">提示词</span>
      </div>

      <div class="row-start menu-box" @click="goChat2BI">
        <el-icon style="font-size:16px;"><PieChart /></el-icon>
        <span style="margin-left:15px;font-size: 14px">ChatBI</span>
      </div>

      <div class="row-start menu-box" @click="goReader">
        <el-icon style="font-size:16px;"><Reading /></el-icon>
        <span style="margin-left:15px;font-size: 14px">智能阅读</span>
      </div>
    <div class="row-start menu-box">
      <el-icon style="font-size:16px;"><Clock /></el-icon>
      <span style="margin-left:15px;font-size: 14px">历史对话</span>
    </div>
    <div style="flex-grow: 1.0" class="history-box">
      <div v-for="(content, idx) in history_dias['最近一月']" :key="idx"  class="text-box">{{content}}</div>
    </div>
    <div v-if="store.getters.isLogined" class="row-start"  style="width: 100%">
      <div style="padding: 20px 0px; background-color:#F4F4FE;width:40px; height: 40px; border-radius:50%; border: 1px solid #E4E7ED" class="row">
        <el-icon style="font-size:16px; color:#6467F0;"><UserFilled /></el-icon>
      </div>
      <div style="margin-left: 5px;">{{store.getters.username}}</div>
    </div>
    <div v-else class="row-start" style="width: 100%">
      <div @click="toLoginPage"
           style="padding: 20px 0px;background-color:white;width:40px; height: 40px; border-radius:50%; border: 1px solid #E4E7ED" class="row">
        <el-icon style="font-size:16px;"><UserFilled /></el-icon>
      </div>
      <div style="margin-left: 5px; color:gray">游客</div>
    </div>
  </el-aside>

  <el-container class="column" style="height: 100%">
    <div class="header row">
      <el-button v-if="!showToolMenu" class="row plain-button" @click="clearDialogues" round>
        <el-icon style="font-size:16px"><ChatLineRound /></el-icon>
        <span style="margin-left:5px;font-size: 14px; width: max-content">新建对话</span>
      </el-button>
    </div>

    <div v-if="showToolMenu" style="background-color:white; padding: 20px; width: 50%; display: flex;flex-direction: column; margin-top:-70px">
        <div class="row">
          <div class="row"><img src="https://jzxq123.cn/data/files/robot-logo.png" class="logo"/></div>
          <div style="display: flex; flex-direction: column; margin-left: 10px">
            <div style="font-size: 28px; font-weight: bold; color:black">噼里啪啦</div>
          </div>
        </div>

    </div>

    <div v-if="!showToolMenu" class="mid scroll-container" ref="contentRef" @scroll="handScroll">
      <div v-for="(record, index) in dialogues" :key="index">
        <div v-if="record.role === 'user'" class="row-end" style="margin-left:25%;width: 50%; margin-top:15px">
          <div style="background-color: #6467f0; color: white; border-radius: 15px 0px 15px 15px;padding:8px 15px">{{record.content}}</div>
        </div>
        <div v-if="record.role === 'chain'" style="display: flex;flex-direction: row;margin-left:25%;width:50%;">
            <div class="round row" style="margin-left:-60px;"><img src="https://jzxq123.cn/data/files/robot-logo.png" class="logo"/></div>
            <div style="margin-left:10px;background-color:ghostwhite; border: 0px solid lightgray; border-radius:12px; padding:5px 15px 15px 15px; margin-top:15px;box-sizing: border-box">
              <el-button style="margin-left: -15px;margin-top: 0px; background-color: ghostwhite; color: #6467f0; border: none; border-radius: 15px"><el-icon><SuccessFilled /></el-icon>已完成深度思考</el-button>
              <div class="row-start chain-content">{{record.content}}</div>
            </div>
        </div>
            <div v-if="record.role === 'assistant'" style="margin-left:25%;width: 50%; margin-top: 10px; padding:0px;border-radius:15px; display: flex; flex-direction: column">
              <v-md-editor  v-model="record.content" mode="preview"/>
            </div>
      </div>

        <div v-if="query !== ''" class="row-end" style="margin-left:25%;width: 50%; margin-top:15px">
          <div style="background-color: #6467f0; color: white; border-radius: 15px 0px 15px 15px;padding:8px 15px">{{query}}</div>
        </div>
      <div style="display: flex;flex-direction: row;margin-left:25%;width:50%;">
      <div v-if="chains !== ''" class="round row" style="margin-left:-60px;"><img src="https://jzxq123.cn/data/files/robot-logo.png" class="logo"/></div>
      <div v-if="chains !== ''" style="margin-left:10px;background-color:ghostwhite; border: 0px solid lightgray; border-radius:12px; padding:5px 15px 15px 15px; margin-top:15px;box-sizing: border-box">
      <el-button v-if="runState === '进入思考模式'"
                 style="margin-left: -15px;margin-top: 0px; background-color: ghostwhite; color: #6467f0; border: none; border-radius: 15px" loading>深度思考中</el-button>
      <el-button v-if="runState === '进入回答模式'"
                 style="font-weight:bold;margin-left: -15px;margin-top: 0px; background-color: ghostwhite; color: #6467f0; border: none;border-radius: 15px"><el-icon><SuccessFilled /></el-icon>已完成深度思考</el-button>
      <div class="row-start chain-content">{{chains}}</div>
      </div>
      </div>
        <div v-if="response !== ''" style="margin-left:25%;width: 50%; margin-top: 10px; padding:0px;border-radius:15px; display: flex; flex-direction: column">
          <v-md-editor  v-model="response" mode="preview"/>
          <div style="width:100%; background-color: white;margin-top: -40px;border-radius: 8px">
          <el-button v-if="runState === '进入回答模式'" style="margin-left:0px; background-color: white; color: #6467f0; border:none; width: max-content" loading>努力回答中</el-button>
          </div>
        </div>
      </div>

    <div class="footer column">
      <div class="query-box">
        <textarea rows="1" v-model="content" placeholder="输入要查询的问题"
                  @keydown.enter="avoidEnter" @input="handleInput"
                  class="input-box"
                  oninput="this.style.height='40px'; this.style.height= this.scrollHeight + 'px'" />
        <div class="row-between" style="width:100%">
          <el-button class="row" style="color: #6467f0; background-color:#F4F4FE; border: none;margin-top:0px">
            <img src="/deepseek.svg" style="width: 30px; height: 30px"/><span style="margin-left:-5px">DeepSeek-R1满血版</span>
          </el-button>
          <div v-if="sendLabel === '1'" class="row" style="height: 35px; width: 35px; border-radius: 50%; background-color: lightgray">
               <img src="/send.svg" style="width: 22px; height: 22px" @click="avoidEnter"/>
          </div>
          <div v-if="sendLabel === '2'" class="row" @click="stopGen"
             style="height: 35px; width: 35px; border-radius: 50%; background-color:white; border:3px solid #6467F0">
             <img src="/pause.svg" style="width: 18px; height: 18px; border-radiu:4px"/>
          </div>
          <div v-if="sendLabel === '3'" class="row" style="height: 35px; width: 35px; border-radius: 50%; background-color: #6467F0">
             <img src="/send.svg" style="width: 22px; height: 22px" @click="avoidEnter"/>
          </div>
        </div>
      </div>
      <div style="color:gray; font-size:14px; padding:5px 0px">- 内容由大模型生成，请注意甄别 -</div>
    </div>
  </el-container>
</el-container>

</template>

<script setup>
import {ref, watch, onMounted} from "vue";
import router from "@/router";
import {useStore} from "vuex";
import { fetchEventSource } from '@microsoft/fetch-event-source';
import axios from "axios";


let ctrl = new AbortController();
const store = useStore();
// const isLoggedIn = store.getters.isLoggedIn;
const username = store.getters.username;
const history_dias = ref({});
const response = ref("");
const current_mode = ref("");
const sendLabel = ref("1");
const content = ref("");
const chains = ref("");
const query = ref("");
const contentRef = ref(null);
const runState = ref("");
const dialogues = ref([]);
const showToolMenu = ref(true);
const menuDetail = ref(true);


const closeMenuDetail = () =>{
  menuDetail.value = !menuDetail.value;
}

const toLoginPage = () =>{
  router.push('/login')
}

const avoidEnter = async(event) =>{
  if (event.key === "Enter"){
    event.preventDefault();
  }
  sendLabel.value = "2";
  query.value = content.value;
  content.value = '';
  response.value = '';
  chains.value = '';
  runState.value = '';
  showToolMenu.value = false;
  subscribeToEvents();
}

const goPrompt = () =>{
  router.push("/prompts");
}

// const goAgent = () =>{
//   router.push("/agents");
// }

const goChat2BI = () =>{
  router.push("/chat2bi");
}

// const goHuman = () =>{
//   router.push("/human");
// }

const goReader = () =>{
  router.push("/read");
}

// const goTest = () =>{
//   router.push("/test");
// }
//
// const goDataMan = () =>{
//   router.push("/data");
// }

const clearDialogues = () =>{
  dialogues.value = [];
  showToolMenu.value = true;
}

const save_user_dialogue = async(records) =>{
  const response = await axios.post('/signin', {
    'username': store.getters.username,
    'password': store.getters.token,
    'op': 'save_user_dialogue',
    'records': records
  });
  console.log(response);
}

const subscribeToEvents = async () => {
  try {
    let mess = [];
    for(let i = 0; i < dialogues.value.length; i += 1){
      if (dialogues.value[i].role != 'chain') {
        mess.push(dialogues.value[i]);
      }
    }
    mess.push({"role": "user", "content": query.value})
    await fetchEventSource('/sseai', {
      method: "POST",
      body: JSON.stringify({messages: mess}),
      headers: {
        'Content-Type': 'application/json'
      },
      signal: ctrl.signal,
      onopen: (resp) => {
        if (resp.ok && resp.status === 200) {
          console.log('Connection established');
        } else {
          console.error('Failed to connect:', response);
        }
      },
      onmessage: (message) => {
        if (message.event === ''){
          if (current_mode.value === "进入思考模式"){
            chains.value += "  \r"
          }else{
            response.value += "  \r";
          }
        }else{
          if (message.data === "进入思考模式"){
            current_mode.value = "进入思考模式";
            runState.value = '进入思考模式';
          }
          if (message.data === "进入回答模式"){
            current_mode.value = "进入回答模式";
            runState.value = '进入回答模式';
          }

          if (current_mode.value === "进入思考模式"){
            if (message.data !== "进入思考模式"){
              chains.value += message.data;
            }
          }else{
            if (message.data !== "进入回答模式"){
              response.value += message.data;
            }
          }
        }
        // console.log(response.value)
      },
      onerror: (err) => {
        console.error('Error occurred:', err);
        if (ctrl && !ctrl.signal.aborted){
          ctrl.abort();
          ctrl = new AbortController();
        }
        sendLabel.value = "1";
        runState.value = '';
      },
      onclose: async () => {
        let records = [
          {
            "role": "user",
            "content": query.value
          },
          {
            "role": "assistant",
            "content":{
              "chains": chains.value,
              "content": response.value
            }
          }
        ];
        await save_user_dialogue(records);
        console.log('Connection closed');
        sendLabel.value = "1";
        runState.value = '';
        dialogues.value.push({"role": "user", "content": query.value});
        dialogues.value.push({"role": "chain", "content": chains.value});
        dialogues.value.push({"role": "assistant", "content": response.value});
        response.value = '';
        chains.value = '';
        query.value = '';
      },
      onfinish:() => {
        console.log('Finished receiving events');
      }
  });
  } catch (err) {
    console.error('Unexpected error:', err);
  }
}


const stopGen = () =>{
  if (ctrl && !ctrl.signal.aborted){
    ctrl.abort();
    ctrl = new AbortController();
  }
  sendLabel.value = "1";
  runState.value = '';
}

const handleInput = () =>{
  sendLabel.value = '3';
}

function handScroll(event){
  const {scrollTop, scrollHeight, clientHeight} = event.target;
  if (scrollTop && scrollHeight && clientHeight && scrollTop + clientHeight >= scrollHeight){
    contentRef.value.scrollTop = scrollHeight;
  }
}

function scrollToBottom(){
  if (contentRef.value){
    contentRef.value.scrollTop = contentRef.value.scrollHeight;
  }
}

watch(response,()=>{
  scrollToBottom();
})

watch(chains, ()=>{
  scrollToBottom();
})

onMounted(async ()=>{
  // console.log(isLoggedIn);
  console.log(username);
  console.log("======");
  const response = await axios.post('/signin', {
    'username': store.getters.username,
    'password': store.getters.token,
    'op': 'query_user_dialogue',
  });
  console.log(response.data.data);
  history_dias.value = response.data.data;
})

</script>

<style scoped>
:root {
  --v-md-editor-padding: 0px;
}

*{
  margin: 0;
}

.el-container{
  margin: 0;
}

.round-box{
  padding:10px;
  border-radius: 50%;
  margin-top: 20px;
  color:black;
  border: 2px solid ghostwhite;
}

.round-box:hover{
  color: #6467F0;
  font-weight: bold;
  border: 2px solid #EBEEF5;
  background-color:#F4F4FE;
}

.header, .mid ,.footer{
  width:100%;
  padding: 10px 0px;
  box-sizing: border-box;
}

.footer{
  padding: 0px;
}

.menu-box{
  padding: 8px;
  width: 100%;
  margin-left: 0%;
  border-radius: 8px;
  border: 1px solid ghostwhite;
  box-sizing: border-box;
}

.menu-box:hover{
  background-color: white;
  border-radius: 8px;
  border: 1px solid #EBEEF5;
  color:black;
}

.header{
  padding: 15px;
  height: 50px;
  box-sizing: border-box;
}

.mid{
  padding: 15px 0px;
  flex-grow: 1;
}

.scroll-container{
  overflow: auto;
  scrollbar-width: none;
}

/* 自定义滚动条样式 */
.scroll-container::-webkit-scrollbar {
  /*width: 5px; !* 滚动条宽度 *!*/
  /*height:20px;*/
  display: none; /* 隐藏滚动条 */
}

.chain-content{
  width: 100%;
  margin-top: 0px;
  border-radius: 0px;
  background-color: ghostwhite;
  padding:0px 10px;
  color:gray;
  border-left: 1px solid #d1d5da;
  max-height: 300px;
  overflow: auto;
  line-height: 30px;
  scrollbar-width: none;
}

.v-md-editor{
  padding: var(--v-md-editor-padding);
  border-radius: 12px;
  width: 100%;
  border:1px solid #F2F6FC;
  background-color: #FFFFFF;
  font-size:16px;
  color: black;
  text-align: left;
  /*box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.1);*/
  font-family: 'Arial', sans-serif;
}
.v-md-editor:hover{
  box-shadow:var(--el-box-shadow-lighter);
}

.input-box{
  resize:none;
  overflow:hidden;
  box-sizing:border-box;
  height:50px;
  line-height:25px;
  width:100%;
  text-align: left;
  outline: none;
  border:0px solid lightgray;
  font-size:16px;
  max-height: 150px;
  text-indent: 0px;
}

.query-box{
  border:2px solid #EBEEF5;
  width:50%;
  padding: 10px 5px 5px 5px;
  border-radius: 15px;
}

.query-box:hover{
  border:2px solid #6467F0;
  box-shadow: var(--el-box-shadow-light);
}

.menu{
  margin-top: 15px;
  padding:5px 0px;
  width: 50px;
  height: 50px;
  box-sizing: border-box;
}



.text-box{
  width: 100%;
  margin-left: 0%;
  padding:8px;
  box-sizing: border-box;
  border-radius: 8px;
  border: 1px solid ghostwhite;
  font-size:15px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.text-box:hover{
  background-color: white;
  color: #6467F0;
  border-radius: 8px;
  border: 1px solid #F2F6FC;
}


.menu:hover{
  margin-top: 15px;
  color: black;
  background-color: #F4F4FE;
  border-radius: 50%;
  padding:5px 0px;
  width: 50px;
  height: 50px;
  box-sizing: border-box;
  border: 1px solid #F2F6FC;
  font-weight:bold;
  color: #6467f0;
}


.round{
  width:50px;
  height: 50px;
  border-radius: 50%;
  margin-top: 0px;
}

.round:hover{
  background-color: #EFEDFE;
}

.history-box{
  width:200px;
  height: 100vh;
  padding: 0px;
  background-color: ghostwhite;
  border-right: 1px solid #F2F6FC;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 5px;
}

.router-fields{
  margin-left: 0px;
  width: max-content;
  height:100%;
  padding:10px;
  display: flex;
  background-color: ghostwhite;
  box-sizing: border-box;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  color: gray;
  overflow-x: hidden;
  border-right: 1px solid #EBEEF5;
}

.column{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.row{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.row-end{
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}

.row-start{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.read-logo{
  width: 25px;
  height: 25px;
  background-size: cover;
  background-position: center;
  background-image: url("/public/read.svg");
}

.read-logo:hover{
  width: 25px;
  height: 25px;
  background-size: cover;
  background-position: center;
  background-image: url("/public/read-active.svg");
}




</style>